import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { User } from 'src/models/user.model';
import { HelpersService } from '../helpers.service';

export interface AuthResponse {
  status: string;
  accessToken: string;
  user: User;
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private url!: string;
  public userSubject!: BehaviorSubject<any>;
  public isLoginSubject!: BehaviorSubject<boolean>;
  public user!: Observable<any>;
  private urlAdmin!: string;

  constructor(private httpClient: HttpClient) {
    this.userSubject = new BehaviorSubject<any>(null);
    this.isLoginSubject = new BehaviorSubject<boolean>(this.hasToken());
    this.user = this.userSubject.asObservable();
  }

  loadConfig() {
    this.url = HelpersService.api('auth');
    this.urlAdmin = HelpersService.api('auth/login-admin');
  }

  login(email: string, password: string): Observable<any> {
    return this.httpClient
      .post<any>(`${this.url}/login/pc`, {
        email,
        password,
      })
      .pipe(
        map((data: AuthResponse) => {
          localStorage.setItem('accessToken', data.accessToken);
          localStorage.setItem('user', JSON.stringify(data.user));
          return data;
        })
      );
  }

  adminLogin(email: string, password: string) {
    return this.httpClient
      .post<AuthResponse>(this.urlAdmin, {
        email,
        password,
      })
      .pipe(
        map((data: AuthResponse) => {
          localStorage.setItem('accessToken', data.accessToken);
          localStorage.setItem('user', JSON.stringify(data.user));
          return data;
        })
      );
  }
  logout(): Observable<any> {
    return this.httpClient.post<any>(`${this.url}/logout`, {});
  }

  getCurrentUser(authBody: any): Observable<User | null> {
    const { email, password } = authBody;
    return this.httpClient.post<any>(`${this.url}/user/getOne`, {
      email,
      password,
    });
  }

  public get userValue(): any {
    return this.userSubject.value;
  }

  public hasToken(): boolean {
    return !!localStorage.getItem('accessToken');
  }
}
